import { SegmentSchema } from '@sondermind/segment';

export interface IAccountCompleteData {
  submittedAt: string;
}

export interface IBasicInfoStarted {
  acType: BasicInfoStartedType;
  directBookingModal: boolean;
}

export interface ICostEstimateDisplayedData {
  coverageType: string;
  payerName: string;
  costEstimate: number;
}

export interface ISelfPayCostEstimateShownData {
  fromDirectBooking: boolean;
  featuredEstimates: Array<{ serviceLabel: string; amount: number; }>;
  personaClientId: string;
  telehealth?: boolean;
  psychiatryIntake?: boolean;
}

export enum BasicInfoStartedType {
  PROPOSE_A_TIME = 'PaT',
  REQUEST_TO_SCHEDULE = 'RtS',
  INDEPENDENT = 'Independent'
}

export enum CurrentUserSegmentEvents {
  ACCOUNT_COMPLETED = 'Account Completed',
  BASIC_INFO_STARTED = 'Basic Info Started',
  COST_ESTIMATE_DISPLAYED = 'Cost Estimate Displayed',
  SELF_PAY_COST_ESTIMATE_SHOWN = 'Self Pay Cost Estimate Shown'
}

export interface ICurrentUserSegmentSchema extends SegmentSchema {
  [CurrentUserSegmentEvents.ACCOUNT_COMPLETED]: IAccountCompleteData;
  [CurrentUserSegmentEvents.BASIC_INFO_STARTED]: IBasicInfoStarted;
  [CurrentUserSegmentEvents.COST_ESTIMATE_DISPLAYED]: ICostEstimateDisplayedData;
  [CurrentUserSegmentEvents.SELF_PAY_COST_ESTIMATE_SHOWN]: ISelfPayCostEstimateShownData;
}
